var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 9.6V17.6M8.39844 13.8908C4.88024 14.4841 2.39844 15.9213 2.39844 17.6C2.39844 19.8091 6.6965 21.6 11.9984 21.6C17.3004 21.6 21.5984 19.8091 21.5984 17.6C21.5984 15.9213 19.1166 14.4841 15.5984 13.8908M15.1984 5.6C15.1984 7.36731 13.7657 8.8 11.9984 8.8C10.2311 8.8 8.79844 7.36731 8.79844 5.6C8.79844 3.83269 10.2311 2.4 11.9984 2.4C13.7657 2.4 15.1984 3.83269 15.1984 5.6Z",
    stroke: "#0057FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCircle);
export default __webpack_public_path__ + "static/media/marker-circle.13dc5d8a66b96e889f3a2ac85f044277.svg";
export { ForwardRef as ReactComponent };